import _ from "lodash"

// Run tests: jest src/models/__tests__/Sku.model.spec.js
export default class Sku {
  constructor(data) {
    this._rawData = data
  }

  get id() {
    return _.get(this._rawData, 'id')
  }

  get name() {
    return _.get(this._rawData, 'sku_name')
  }

  get productName() {
    return _.get(this._rawData, 'product.title')
  }

  get nameWithProductName() {
    return _.uniq([this.productName, this.name])
      .filter(Boolean)
      .join(' ')
  }

  get description() {
    return _.get(this._rawData, 'product.description')
  }

  get image() {
    return _.get(this._rawData, 'product.images[0].pic_url')
  }

  get originalPrice() {
    return Number(_.get(this._rawData, 'price', 0))
  }

  get discountedPrice() {
    return Number(_.get(this._rawData, 'suggest_price', 0)) || Number(_.get(this._rawData, 'price', 0))
  }

  get isDiscounted() {
    return this.discountedPrice !== 0 && this.discountedPrice !== this.originalPrice // 0 也視為未打折
  }

  get point() {
    return Number(_.get(this._rawData, 'point', 0))
  }

  get remainingStock() {
    return Number(_.get(this._rawData, 'quantity', 0))
  }
}
